// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/New-Products/new/seblock-5.jpeg";
import thumb1 from "../assets/images/New-Products/new/seblock-5.jpeg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/0_Molecular_Cosmetics_1920x1080 (1).mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";



const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb1].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>Seblok-5mg </h2>
              <p className="sub-heading text-muted">Softgel capsules for treatment of Acne. </p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>Seblok An anti-acne medication targeted towards reducing recalcitrant nodulocystic acne present on the face.</li>
                  <li>Isotretinoin Seblok belongs to a class of drugs known as retinoids. It works by decreasing facial oil (sebum) production.</li>
                  <li>High amounts of sebum can lead to severe acne. If left untreated, severe acne may cause permanent scarring.</li>
                  <li>Seblok treats severe acne that is resistant to other forms of treatment like antibiotics and topical medications.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">Seblok-5mg?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use.
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "side_effects", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "side_effects"
                      ? "SIDE EFFECTS"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <p><strong>Seblok belongs to a class of drugs known as retinoids. It works by decreasing facial oil (sebum) production</strong></p>
                  <ul>
                    <li>Severe nodulocystic acne</li>
                    <li>Severe papulopustular acne</li>
                    <li>Moderate to severe nodular acne</li>
                    <li>Minimal response to previous treatments</li>
                    <li>Prone to significant scarring</li>
                    <li>Sudden relapse after stopping therapy</li>
                    <li>Patients with significant psychological distress</li>
                  </ul>


                </div>
              )}
              {activeTab === "side_effects" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Isotretinoin can cause birth defects (systemic retinoids), drugs interactions can alter medication effectiveness and increase the risk of serious side effects.</li>                                            
                      <li>Dryness of your skin, lips, eyes, or nose</li>
                      <li>Joint pain</li>
                      <li>Muscle problems</li>
                      <li>Headache</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li><strong>Isotretinoin</strong> </li>
                      <li><strong>Sebosuppressive effects:</strong> Marked reduction in the size and activity of sebaceous glands. Causes sebocyte apoptosis and creates an unfavorable microenvironment for the proliferation of <em>Propionibacterium acnes</em>.</li>
                      <li><strong>Comedolytic effects:</strong> Reduces hyperkeratinization by affecting follicular and sebaceous gland differentiation.</li>
                      <li><strong>Anti-inflammatory and immunological effects:</strong> Reduces expression of Toll-Like Receptor-2 in circulating mononuclear cells, increases host defense mechanisms, and modifies monocyte chemotaxis.</li>
                    </ul>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
